/*
  * status_recv: 0, initial; 1, image_orth; 2, image_flash;
  *3: image_up; 4: up_flash; 5: image_back; 6, other
*/
/* eslint no-bitwise: ["error", { "allow": ["<<"] }] */

const WARPVALCOS = 0.1;
const UPTILTT = 0.10;
const DISTANCET = 0.65;
const TAN15 = 0.178;
const ECEEDBUFFER = 12;

export default class Coordinate {

    constructor({ points, imgSize }) {
        this.points = points;
        this.imgSize = imgSize;
        this.distance = [];
    }

    setPoints(points = null) {
        this.points = points;
        this.distance = [];
        return this.getAllDistances();
    }

    getAllDistances() {
        const { points } = this;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 4; i++) {
            const next = (i + 1) % 4;
            const distance = Coordinate.getDistance(
                points[i << 1],
                points[next << 1],
                points[(i << 1) + 1],
                points[(next << 1) + 1],
            );
            this.distance.push(distance);
        }

        return this.distance;
    }

    exceed(imageWidth, offsetX, offsetY) {
        const ratioL = (offsetX - ECEEDBUFFER) / imageWidth;
        const ratioT = (offsetY - ECEEDBUFFER) / imageWidth;
        const ratioB = (imageWidth - offsetY + ECEEDBUFFER) / imageWidth;
        const ratioR = (imageWidth - offsetX + ECEEDBUFFER) / imageWidth;
        if (this.points[0] / this.imgSize < ratioL || this.points[2] / this.imgSize < ratioL) {
            return 'EXCEED_LEFT';
        }

        if (this.points[1] / this.imgSize < ratioT || this.points[7] / this.imgSize < ratioT) {
            return 'EXCEED_TOP';
        }

        if (this.points[3] / this.imgSize > ratioB || this.points[5] / this.imgSize > ratioB) {
            return 'EXCEED_BOTTOM';
        }

        if (this.points[4] / this.imgSize > ratioR || this.points[6] / this.imgSize > ratioR) {
            return 'EXCEED_RIGHT';
        }
        return true;
    }

    static getDistance(x1, x2, y1, y2) {
        const distance = (x1 - x2) ** 2 + (y1 - y2) ** 2;
        return Math.sqrt(distance);
    }

    checkRight(type, points, distance, pictureParams) {
        const exceedStatus = this.exceed(
            pictureParams.imageWidth,
            pictureParams.offsetX,
            pictureParams.offsetY,
        );

        if (exceedStatus !== true) {
            return exceedStatus;
        }

        const realTan = Coordinate.checkTan(points, TAN15);
        if (realTan === 'MOREA') {
            return realTan;
        }

        switch (type) {
            //  正面和背面
            case 1: // orth
            case 2: // orth flash
            case 5: {
                const precondition = Coordinate.distantSide(distance, this.imgSize);
                return precondition === true ? Coordinate.checkRightOrth(points, distance) : precondition;
            }
            // 斜面
            case 3:
            case 4: {
                const precondition = Coordinate.checkRotate(distance);
                return precondition === true ? Coordinate.checkRightUp(distance) : precondition;
            }
            default: return true;
        }
    }

    static checkRightOrth(points, distance) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 4; i++) {
            const prevIndex = (i + 4 - 1) % 4;
            const nextIndex = (i + 4 + 1) % 4;
            const prevDis = distance[prevIndex];
            const nextDis = distance[i];
            // m_loc length
            const x = points[i << 1]; const
                y = points[(i << 1) + 1];
            const x1 = points[prevIndex << 1] - x;
            const y1 = points[(prevIndex << 1) + 1] - y;
            const x2 = points[nextIndex << 1] - x;
            const y2 = points[(nextIndex << 1) + 1] - y;
            const cos = (x1 * x2 + y1 * y2) / (prevDis * nextDis);
            // right angle
            if (Math.abs(cos) > WARPVALCOS) return 'MORE_ROTATE';
        }
        return true;
    }

    static checkRightUp(distance) {
        return Math.abs(distance[0] - distance[2]) / Math.max(distance[0], distance[2]) < UPTILTT;
    }

    static checkRotate(distance) {
        const ratio = distance[3] / distance[1];
        if (ratio > 0.9) {
            return 'LESS_ROTATE';
        }
        if (ratio < 0.80) {
            return 'MORE_ROTATE';
        }
        return true;
    }

    static distantSide(distance, imgSize) {
        const longer = Math.max(distance[1], distance[3]);
        const ratio = longer / imgSize;
        if (ratio < DISTANCET) {
            return 'FAR';
        }

        return true;
    }

    static checkTan(points, ratio) {
        const realRotio = Math.abs((points[7] - points[1]) / (points[6] - points[0]));
        if (realRotio > ratio) {
            return 'MOREA';
        }

        return true;
    }
}
